const NoFilteredCars = ({ isMobile, isActiveComp }: { isMobile: boolean; isActiveComp: boolean }) => {
  const message = isMobile
    ? "There are no cars matching your current criteria. Please change the search settings above."
    : "There are no cars matching your current criteria. Please change the search settings or click the Reset button above.";

  const getMessage = () => {
    if (isActiveComp) {
      if (isMobile) {
        return (
          <>
            <h3 className={`text-2xl my-4`}>No Cars found</h3>
            <p className="py-2">
              There are no cars matching your current criteria. Please change the search settings above.
            </p>
          </>
        );
      }
      return (
        <>
          <h3 className={`text-2xl my-4`}>No Cars found</h3>
          <p className="py-2">
            There are no cars matching your current criteria. Please change the search settings or click the Reset
            button above.
          </p>
        </>
      );
    } else {
      const currentDate = new Date();
      if (currentDate.getHours() === 0 && currentDate.getMinutes() === 0) {
        return (
          <p>
            The last competition has just ended. There'll be a new competition starting in a minute. <br />
            Please check back shortly.
          </p>
        );
      }
      return (
        <p>
          We've taken this competition off to the mechanics to get a few modifications installed.
          <br />
          Our mechanic is pretty quick though, so check back in 15 minutes or so. In the meantime why not try one of our
          other competitions?
        </p>
      );
    }
  };

  return (
    <div className="grid justify-center text-center mt-10">
      <img src="/assets/images/icon-no-cars.png" width={100} height={100} alt="NoCarsSearchImage" className="m-auto" />
      {getMessage()}
    </div>
  );
};

export default NoFilteredCars;
